// @flow
import {useEffect, useState} from 'react';
import {getDeliveryMethodsApi} from '../api';
import {useSelector} from 'react-redux';
import type {RootState} from '../..';
import type {PickupMethod} from '../../../entities';

const storeSelector = (state: RootState) => state.store.store;

export function useAddressPickup() {
  const [pickupMethods, setPickupMethods] = useState<PickupMethod[]>([]);
  const [isLoadingPickup, setIsLoadingPickup] = useState(false);
  const store = useSelector(storeSelector);

  useEffect(() => {
    setIsLoadingPickup(true);
    getDeliveryMethodsApi({
      delivery_method: 'PICK_UP',
      store_id: store.id,
      //   country
    })
      .toPromise()
      .then(pickUpMethods => {
        setPickupMethods(pickUpMethods);
        setIsLoadingPickup(false);
      })
      .catch(() => {
        setIsLoadingPickup(false);
      });
  }, [store.id]);

  return {
    pickupMethods,
    isLoadingPickup,
  };
}
